import { Theme, createStyles } from '@zn-material-ui'

export default (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      height: '70px',
      color: '#323232',
      fontSize: '24px',
      textAlign: 'center',
      padding: 0,
      display: 'flex',
      justifyContent: 'center',
    },
    closeButton: {
      position: 'absolute',
      right: 5,
      top: 5,
      padding: 0,
      color: theme.palette.grey[600],
      '&:hover': {
        background: 'none',
      },
    },
  })
